module.exports = __webpack_public_path__ + "static/media/8-7.7224f24d.mp3";